var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual-full', {
    attrs: {
      "bg": "/images/sub/visual/sv4-1.jpg"
    }
  }, [_c('div', {
    staticClass: "text-ani-wrap"
  }, [_c('div', {
    staticClass: "text-ani mb-14 mb-lg-28"
  }, [_c('h2', {
    staticClass: "font-weight-bold line-height-1"
  }, [_vm._v("인재상")])]), _c('div', {
    staticClass: "text-ani"
  }, [_c('p', {
    staticClass: "tit-txt color-grey-d"
  }, [_vm._v("세일즈웍스는 변하지 않는 핵심가치 PICCCSA와 함께합니다.")])])])]), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('v-row', {
    attrs: {
      "row--large": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "pb-20 pb-lg-30 border-bottom w-100"
  }, [_c('div', {
    attrs: {
      "data-aos": "fade-left"
    }
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold mb-2 mb-lg-0"
  }, [_c('span', {
    staticClass: "color-point"
  }, [_vm._v("P")]), _vm._v("ASSION ")]), _c('p', {
    staticClass: "page-text--sm font-weight-bold mb-14 mb-lg-26"
  }, [_vm._v(" 고객사, 동료, 팀원을 향한 열정 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-7 mb-16 mb-lg-30"
  }, [_vm._v(" 열정적이고 목표 지향적인 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 문화 속에 긍정적인 에너지를 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 전달합니다. ")])]), _c('h2', {
    staticClass: "font-size-50 font-size-md-80 font-size-lg-150 font-weight-bold color-point text-right line-height-1",
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_vm._v("P")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "pb-20 pb-lg-30 border-bottom w-100"
  }, [_c('div', {
    attrs: {
      "data-aos": "fade-left"
    }
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold mb-2 mb-lg-0"
  }, [_c('span', {
    staticClass: "color-point"
  }, [_vm._v("I")]), _vm._v("NTEGRITY ")]), _c('p', {
    staticClass: "page-text--sm font-weight-bold mb-14 mb-lg-26"
  }, [_vm._v(" 정직 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-7 mb-16 mb-lg-30"
  }, [_vm._v(" 바른 태도로 정직하게 일하며, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 투명하게 맡은 역할에 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 최선을 다합니다. ")])]), _c('h2', {
    staticClass: "font-size-50 font-size-md-80 font-size-lg-150 font-weight-bold color-point text-right line-height-1",
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_vm._v("I")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "pb-20 pb-lg-30 border-bottom w-100"
  }, [_c('div', {
    attrs: {
      "data-aos": "fade-left"
    }
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold mb-2 mb-lg-0"
  }, [_c('span', {
    staticClass: "color-point"
  }, [_vm._v("C")]), _vm._v("OMMUNICATION ")]), _c('p', {
    staticClass: "page-text--sm font-weight-bold mb-14 mb-lg-26"
  }, [_vm._v(" 열린 소통과 존중 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-7 mb-16 mb-lg-30"
  }, [_vm._v(" 열린 마음으로 소통하고, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 편견과 차별 없이 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 상대방 의견을 존중합니다. ")])]), _c('h2', {
    staticClass: "font-size-50 font-size-md-80 font-size-lg-150 font-weight-bold color-point text-right line-height-1",
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_vm._v("C")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "pb-20 pb-lg-30 border-bottom w-100"
  }, [_c('div', {
    attrs: {
      "data-aos": "fade-left"
    }
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold mb-2 mb-lg-0"
  }, [_c('span', {
    staticClass: "color-point"
  }, [_vm._v("C")]), _vm._v("HALLENGES ")]), _c('p', {
    staticClass: "page-text--sm font-weight-bold mb-14 mb-lg-26"
  }, [_vm._v(" 도전 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-7 mb-16 mb-lg-30"
  }, [_vm._v(" 끊임없는 도전으로 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 자신의 한계를 뛰어넘고 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 최상의 결과를 만들어 냅니다. ")])]), _c('h2', {
    staticClass: "font-size-50 font-size-md-80 font-size-lg-150 font-weight-bold color-point text-right line-height-1",
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_vm._v("C")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "pb-20 pb-lg-30 border-bottom w-100"
  }, [_c('div', {
    attrs: {
      "data-aos": "fade-left"
    }
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold mb-2 mb-lg-0"
  }, [_c('span', {
    staticClass: "color-point"
  }, [_vm._v("C")]), _vm._v("ELEBRATING ")]), _c('p', {
    staticClass: "page-text--sm font-weight-bold mb-14 mb-lg-26"
  }, [_vm._v(" 축하&격려 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-7 mb-16 mb-lg-30"
  }, [_vm._v(" 성취한 것에 대해 함께 축하하며, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 상대방의 노력을 인정하고 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 격려합니다. ")])]), _c('h2', {
    staticClass: "font-size-50 font-size-md-80 font-size-lg-150 font-weight-bold color-point text-right line-height-1",
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_vm._v("C")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "pb-20 pb-lg-30 border-bottom w-100"
  }, [_c('div', {
    attrs: {
      "data-aos": "fade-left"
    }
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold mb-2 mb-lg-0"
  }, [_c('span', {
    staticClass: "color-point"
  }, [_vm._v("S")]), _vm._v("ELF IMPROVEMENT ")]), _c('p', {
    staticClass: "page-text--sm font-weight-bold mb-14 mb-lg-26"
  }, [_vm._v(" 자기계발 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-7 mb-16 mb-lg-30"
  }, [_vm._v(" 잠재력을 최대한 끌어내어 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 역량을 강화하고 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 성장합니다. ")])]), _c('h2', {
    staticClass: "font-size-50 font-size-md-80 font-size-lg-150 font-weight-bold color-point text-right line-height-1",
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_vm._v("S")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "pb-20 pb-lg-30 border-bottom w-100"
  }, [_c('div', {
    attrs: {
      "data-aos": "fade-left"
    }
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold mb-2 mb-lg-0"
  }, [_c('span', {
    staticClass: "color-point"
  }, [_vm._v("A")]), _vm._v("CCOUNTABILITY ")]), _c('p', {
    staticClass: "page-text--sm font-weight-bold mb-14 mb-lg-26"
  }, [_vm._v(" 책임감 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-7 mb-16 mb-lg-30"
  }, [_vm._v(" 자신의 행동 및 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 맡은 역할에 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 책임을 다합니다. ")])]), _c('h2', {
    staticClass: "font-size-50 font-size-md-80 font-size-lg-150 font-weight-bold color-point text-right line-height-1",
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_vm._v("A")])])])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }